import { render, staticRenderFns } from "./reactivos-ordenamiento.vue?vue&type=template&id=9f8651b2&scoped=true&"
import script from "./reactivos-ordenamiento.vue?vue&type=script&lang=js&"
export * from "./reactivos-ordenamiento.vue?vue&type=script&lang=js&"
import style0 from "./reactivos-ordenamiento.vue?vue&type=style&index=0&id=9f8651b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8651b2",
  null
  
)

export default component.exports